import React, { useState, useEffect } from 'react';
import { callApi, getEndpoint } from '../../../utils/api';
import Accordion from './Accordion';
import PropTypes from 'prop-types';
import './Faq.scss';

const Faq = ({ endPoint }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchFaqDetails = async () => {
      try {
        const response = await callApi(getEndpoint(endPoint, {}, true));
        const faqData = response?.body[':items']?.root[':items'];
        const faqArray = Object.values(faqData);
        return faqArray?.map((item) => ({
          question: item.elements.question.value,
          answer: item.elements.answer.value,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    fetchFaqDetails().then((res) => {
      setData(res);
    });
    return () => {
      setData([]);
    };
  }, [endPoint]);

  return (
    <div className="faq-cont">
      {data?.map((item) => {
        return (
          <Accordion
            question={item.question}
            answer={item.answer}
            key={item.question}
          />
        );
      })}
    </div>
  );
};

Faq.propTypes = {
  endPoint: PropTypes.string.isRequired,
};

export default Faq;
